import type { ElementType, ReactNode } from "react";
import styles from "./Container.module.css";

/** The one page gutter. Mobile-first: 16px, widening to 32px from 768px. */
export function Container({
  as: Tag = "div",
  id,
  className,
  children,
}: {
  as?: ElementType | undefined;
  /** Needed by the page's main landmark, which the skip link targets. */
  id?: string | undefined;
  className?: string | undefined;
  children: ReactNode;
}) {
  return (
    <Tag id={id} className={[styles.container, className].filter(Boolean).join(" ")}>
      {children}
    </Tag>
  );
}
